import { useBasicFileUpload, UseFileUpload } from './useBasicFileUpload';
import { SelectedImage, useValidateImage } from './utils/validateImage';

export const useImageUpload = (props: UseFileUpload<SelectedImage>) => {
  const validate = useValidateImage();
  return useBasicFileUpload({
    ...props,
    validate,
  });
};
